import axios from 'axios';
import { Storage } from '@/services/storage.service';

// workaround for cyclic imports
const storePromise = import('@/store');

const ApiService = {
  init(endpoint) {
    let store;
    axios.defaults.baseURL = endpoint;
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.defaults.withCredentials = true;
    axios.interceptors.request.use((requestConfig) => {
      const token = Storage.getToken();
      if (token) {
        const targetTimestamp = Storage.getTokenExpireTime();
        if (targetTimestamp) {
          const currentTime = Math.floor(Date.now() / 1000);
          const timeDifference = targetTimestamp - currentTime;
          if (timeDifference <= 0) {
            localStorage.clear();
            window.location.href = window.location.origin;
          }
        }
        return {
          ...requestConfig,
          headers: {
            ...requestConfig.headers,
            Authorization: `Bearer ${token}`,
          },
        };
      }
      return requestConfig;
    });
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (store == null) {
          store = (await storePromise).default;
        }
        const code = error.request.status;
        switch (code) {
          case 401:
            // Unauthorized

            // store.commit('user/sessionExpired');
            // do nothing for now
            // throw error;
            await store.dispatch('auth/cookie');
            // retry original request
            return this.request(error.config);

          case 419:
            // CSRF-token mismatch
            // refresh CSRF token
            await store.dispatch('auth/cookie');
            // retry original request
            return this.request(error.config);

          default:
            throw error;
        }
      },
    );
  },
  setLang(lang) {
    axios.defaults.headers.common['Accept-Language'] = lang;
  },
  setHeader(token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
  removeHeader() {
    axios.defaults.withCredentials = false;
    axios.defaults.headers.common = {};
  },
  get(path, config = undefined) {
    return axios.get(path, config);
  },
  post(path, data, config = undefined) {
    return axios.post(path, data, config);
  },
  put(path, data, config = undefined) {
    return axios.put(path, data, config);
  },
  patch(path, data, config = undefined) {
    return axios.patch(path, data, config);
  },
  delete(path, config = undefined) {
    return axios.delete(path, config);
  },
  request(config) {
    return axios(config);
  },
  enableAuthErrorInterceptor() {},
  disableAuthErrorInterceptor() {},
};

export default ApiService;
